import api from './api';

export const getNotificationTemplates = async (params = {}) => {
  const response = await api.get('/api/notification-templates', { params });
  return response.data;
};

/** Категории берём из базы, а не из списка в коде — иначе фильтр расходится с данными */
export const getNotificationTemplateCategories = async () => {
  const response = await api.get('/api/notification-templates/categories');
  return response.data;
};

export const getNotificationTemplateById = async (id) => {
  const response = await api.get(`/api/notification-templates/${id}`);
  return response.data;
};

export const updateNotificationTemplate = async (id, data) => {
  const response = await api.put(`/api/notification-templates/${id}`, data);
  return response.data;
};

export const previewNotificationTemplate = async (id, testData = {}) => {
  const response = await api.post(`/api/notification-templates/${id}/preview`, { testData });
  return response.data;
};

export const getAvailableSegments = async () => {
  const response = await api.get('/api/notification-templates/segments');
  return response.data.segments || [];
};
